import type { RouteRecordRaw } from 'vue-router';

import { ERouteName } from '~/app/router/routeName.enum';
import { aboutPageRoutes } from './aboutRoutes';
import { promoPageRoutes } from './promoRouters';
import { userPageRoutes } from './userPageRoutes';

export const customRoutes = [
  {
    path: '/wishes',
    redirect: '/favorites',
  },

  userPageRoutes,

  ...aboutPageRoutes,
  ...promoPageRoutes,

  {
    name: ERouteName.MAIN,
    path: '/',
    component: () => import('~/pages/index/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.CART,
    path: '/cart',
    component: () => import('~/pages/cart/CartPage.vue'),
    meta: {
      isSearchHiddenOnMobileAndTablet: true,
      isTopHeaderHiddenOnMobileAndTablet: true,
      isBackButtonHidden: true,
      title: 'Корзина',
    },
  },

  {
    name: ERouteName.FAVORITES,
    path: '/favorites',
    component: () => import('~/pages/favorites/index.client.vue'),
  },

  {
    name: ERouteName.CHECKOUT,
    path: '/checkout',
    component: () => import('~/pages/checkout/ui/CheckoutPage.vue'),
    meta: {
      layout: 'clear',
    },
  },

  {
    name: ERouteName.PRODUCT,
    path: '/product/:name(.*?-)?:id(\\d+)',
    component: () => import('~/pages/product/[name]-[id].vue'),
  },

  {
    name: ERouteName.FAQ,
    path: '/faq',
    component: () => import('~/pages/faq/index.client.vue').then((r) => r.default || r),
  },

  // removed /promo/test route

  // {
  //   name: ERouteName.CATEGORY,
  //   path: '/category/:url',
  //   component: () => import('~/pages/category/index.vue').then((r) => r.default || r),
  // },

  {
    name: ERouteName.CATEGORY,
    path: '/category/:name(.*[a-zа-я0-9]-)?:id(-?\\d+)',
    component: () => import('~/pages/category/index.vue').then((r) => r.default || r),
  },

  {
    path: '/category/:pathMatch(.*)*',
    name: ERouteName.CATEGORY_NOT_FOUND,
    component: () => import('~/pages/category/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.SHOP,
    path: '/:shop',
    component: () => import('~/pages/shop/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.SEARCH,
    path: '/search/:query?',
    component: () => import('~/pages/search/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.SALE,
    path: '/promo/whatasale',
    component: () => import('~/pages/landings/11/ui/index.client.vue').then((r) => r.default || r),
    meta: {
      hidePromoPopup: true
    }
  },
] as RouteRecordRaw[];
